import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path d="M7.5 12H13L17.5 7" stroke={fill} strokeWidth="1.5" />
    <path d="M13 12L17 16" stroke={fill} strokeWidth="1.5" />
    <circle cx="18.5" cy="5.5" r="2.5" fill={fill} />
    <circle cx="17.5" cy="17.5" r="2.5" fill={fill} />
    <circle cx="5.5" cy="12" r="2.5" fill={fill} />
  </g>
);

export default Icon;
